import { getDateFieldFormSchema } from '@common*';
import type { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';
import { z } from 'zod';
import { BatchEditRentalConfigurationFormValuesType } from '../../types';

const TRANS_KEY = 'RENTAL_CONFIGURATION_TABLE.FORM.ERRORS';

const buildBatchEditRentalConfigurationFormSchema = (
  t: TFunction<'venueDetailsRental'>
) =>
  z.object({
    validFrom: getDateFieldFormSchema({
      invalidFormatMessage: t(`${TRANS_KEY}.INVALID_FORMAT`),
      invalidDateMessage: t(`${TRANS_KEY}.INVALID_DATE`),
    }),
    validUntil: z
      .union([
        z.literal(''),
        getDateFieldFormSchema({
          invalidFormatMessage: t(`${TRANS_KEY}.INVALID_FORMAT`),
          invalidDateMessage: t(`${TRANS_KEY}.INVALID_DATE`),
        }),
      ])
      .nullable()
      .transform((v) => (v === '' ? null : v)),
  });

type BatchEditRentalConfigurationFormSchemaType = ReturnType<
  typeof buildBatchEditRentalConfigurationFormSchema
>;

type UseBatchEditRentalConfigurationFormSchemaReturnType = {
  schema: BatchEditRentalConfigurationFormSchemaType;
  defaultValues: BatchEditRentalConfigurationFormValuesType;
};

export const useBatchEditRentalConfigurationFormSchema =
  (): UseBatchEditRentalConfigurationFormSchemaReturnType => {
    const { t } = useTranslation('venueDetailsRental');

    const schema = buildBatchEditRentalConfigurationFormSchema(t);

    const defaultValues: BatchEditRentalConfigurationFormValuesType = {
      validFrom: '',
      validUntil: null,
    };

    return { schema, defaultValues };
  };
